(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("besida", [], factory);
	else if(typeof exports === 'object')
		exports["besida"] = factory();
	else
		root["besida"] = factory();
})(window, function() {
return 